import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import Footer from "../../components/footer/component";
import HeaderHomeTwo from "../../components/header-home-two/component";
import {marketRegister} from "../../services/marketRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {dataRegister} from "../../services/dataRegister";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";


class About extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    };

    componentWillMount() {
        window.scrollTo(0, 0)

        //GOOGLE ANALYTICS
        if(this.platformLive()){
            ReactGA.pageview('/about');
            ReactGA4.send({ hitType: "pageview", page: "/about" });
        }

        //FACEBOOK PIXEL
        if(this.platformLive()){
            ReactPixel.pageView();
        }
    }

    _listIndustries(){
        if(dataRegister.api.primehit.indexOf("https://api.devprimehit") !== -1){
            window.open("https://app.devadbop.com/"+marketRegister.code()+"/"+langRegister.lang()+"/adbop/signup/industry", '_blank');
        }else{
            window.open("https://app.adbop.com/"+marketRegister.code()+"/"+langRegister.lang()+"/adbop/signup/industry", '_blank');
        }
    }

    _renderText(item) {
        return langRegister.get("about", item);
    }

    platformLive() {
        try {
            return window.location.hostname.indexOf('dev') === -1;
        } catch (e) {
            return false
        }
    }

    render() {
        return (
              <div className={Styles.view}>
                  <HeaderHomeTwo view={"about"} props={this.props}/>
                  <div className={Styles.sectionOne}>
                      <div className={Styles.sectionOneText}>
                          {this._renderText("item_1")} <br className={Styles.sectionOneTextBreak}/>
                          <span className={Styles.sectionOneTextGreen}>{this._renderText("item_2")}</span>
                          <div className={Styles.sectionOneTextGreenSmall}>
                              {this._renderText("item_3")}
                          </div>
                          <div onClick={() => this._listIndustries()} className={Styles.sectionOneButton}>
                              {this._renderText("item_4")}
                          </div>
                      </div>
                      <div className={Styles.sectionOneFiller}/>
                      <div className={Styles.sectionOneImage}>
                          <img className={Styles.sectionOneImageItem}
                               src={require("../../assets/images/AB_illustration_flight.png")}/>
                      </div>
                  </div>
                  <div className={Styles.sectionTwo}>
                      <img className={Styles.sectionTwoShadow}
                           src={require("../../assets/images/AB_angel_white_desktop.png")}/>
                      <img className={Styles.sectionTwoShadowMobile}
                           src={require("../../assets/images/AB_angel_white_mobile.png")}/>
                      <div className={Styles.sectionTwoInner}>
                          <div className={Styles.sectionTwoImage}>
                              <img className={Styles.sectionTwoImageItem}
                                   src={require("../../assets/images/AB_illustration_greet.png")}/>
                          </div>
                          <div className={Styles.sectionTwoFiller}/>
                          <div className={Styles.sectionTwoText}>
                              {this._renderText("item_5")}
                              <div className={Styles.sectionTwoTextBread}>
                                  {this._renderText("item_6")}
                              </div>
                          </div>
                      </div>
                      <img className={Styles.sectionTwoShadow}
                           src={require("../../assets/images/AB_angel_white_desktop_flipped.png")}/>
                      <img className={Styles.sectionTwoShadowMobile}
                           src={require("../../assets/images/AB_angel_white_mobile_flipped.png")}/>
                  </div>
                  <div className={Styles.sectionThree}>
                      <div className={Styles.sectionThreeText}>
                          {this._renderText("item_7")}
                          <span className={Styles.sectionThreeTextGreen}>{this._renderText("item_8")}</span>
                          {this._renderText("item_9")}
                          <span className={Styles.sectionThreeTextGreen}>{this._renderText("item_10")}</span>
                          {this._renderText("item_11")}
                          <div className={Styles.sectionThreeTextSmall}>
                              {this._renderText("item_12")}
                          </div>
                          <div onClick={() => this._listIndustries()} className={Styles.sectionThreeButton}>
                              {this._renderText("item_13")}
                          </div>
                      </div>
                      <div className={Styles.sectionThreeFiller}/>
                      <div className={Styles.sectionThreeImage}>
                          <img className={Styles.sectionThreeImageItem}
                               src={require("../../assets/images/AB_illustration_cards.png")}/>
                      </div>
                  </div>
                  <Footer props={this.props}/>
              </div>
        );
    }
}

export default About;


// WEBPACK FOOTER //
// ./src/pages/about/component.js